'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('../type/index');

/**
 * tcss图片上报
 * @param  {String} tcssName 对应的按钮名称
 * @param  {Function} [callback] 成功回调
 */
var report = function report() {
    var tcssName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var callback = arguments[1];

    if (tcssName) {
        if ((0, _index.isFunction)(callback)) {
            callback();
        }
    }
};

exports.default = report;